export const OPEN_ADD_INV_ITEM_FORM='OPEN_ADD_INV_ITEM_FORM';
export const CANCEL_ADD_INV_ITEM_FORM='CANCEL_ADD_INV_ITEM_FORM';
export const ADD_NEW_INV_ITEM='ADD_NEW_INV_ITEM';
export const UPDATE_EDIT_INV_ITEM='UPDATE_EDIT_INV_ITEM';
export const INV_ITEM_SELECTED='INV_ITEM_SELECTED';
export const INV_ITEM_DESELECTED='INV_ITEM_DESELECTED';
export const UPDATE_INV_ITEMS='UPDATE_INV_ITEMS';
export const UPDATE_INV_VENDORS='UPDATE_INV_VENDORS';
export const UPDATE_API_ERROR='UPDATE_API_ERROR';
export const INV_SUBMITTED_SUCCESS='INV_SUBMITTED_SUCCESS';
export const INV_SUBMITTED_ERROR='INV_SUBMITTED_ERROR';
export const INV_SUBMITTED_COMPLETED='INV_SUBMITTED_COMPLETED';
export const INV_VALIDATE_VENDOR_N_ACCTNO_SUCCESS='INV_VALIDATE_VENDOR_N_ACCTNO_SUCCESS';
export const INV_VALIDATE_VENDOR_N_ACCTNO_ERROR='INV_VALIDATE_VENDOR_N_ACCTNO_ERROR';
export const INV_CLEAR_VALIDATION='INV_CLEAR_VALIDATION';
export const SELECTED_INV_VENDOR='SELECTED_INV_VENDOR';
export const CLEAR_INV_VENDOR='CLEAR_INV_VENDOR';
export const REFRESH_INV_ACCT_NOS='REFRESH_INV_ACCT_NOS';
export const REFRESH_INV_CUST_NAMES='REFRESH_INV_CUST_NAMES';
export const REFRESH_INV_CHARGE_DESCS='REFRESH_INV_CHARGE_DESCS';
export const REFRESH_INV_SERVICE_ADDRESSES='REFRESH_INV_SERVICE_ADDRESSES';
export const CLEAR_ALL_INV_ITEMS='CLEAR_ALL_INV_ITEMS';
export const SET_INV_ACCT_NO='SET_INV_ACCT_NO';
export const CLEAR_INV_ACCT_NO='CLEAR_INV_ACCT_NO';
export const SAVE_INV_HEADER='SAVE_INV_HEADER';

export const GET_APOLLO_ITEMS_SUCCESS='GET_APOLLO_ITEMS_SUCCESS';
export const GET_APOLLO_ITEMS_ERROR='GET_APOLLO_ITEMS_ERROR';
export const NEW_APOLLO_ITEM_CREATED='NEW_APOLLO_ITEM_CREATED';
export const NEW_APOLLO_ITEM_CREATED_ERROR='NEW_APOLLO_ITEM_CREATED_ERROR';
export const EDIT_APOLLO_ITEM='EDIT_APOLLO_ITEM';
export const UPDATED_APOLLO_ITEM_SUCCESS='UPDATED_APOLLO_ITEM_SUCCESS';
export const UPDATED_APOLLO_ITEM_ERROR='UPDATED_APOLLO_ITEM_ERROR';
export const MOVE_DOWN_APOLLO_ITEM_SUCCESS='MOVE_DOWN_APOLLO_ITEM_SUCCESS';
export const MOVE_DOWN_APOLLO_ITEM_ERROR='MOVE_DOWN_APOLLO_ITEM_ERROR';
export const MOVE_UP_APOLLO_ITEM_SUCCESS='MOVE_UP_APOLLO_ITEM_SUCCESS';
export const MOVE_UP_APOLLO_ITEM_ERROR='MOVE_UP_APOLLO_ITEM_ERROR';
export const DELETE_APOLLO_ITEM_SUCCESS='DELETE_APOLLO_ITEM_SUCCESS';
export const DELETE_APOLLO_ITEM_ERROR='DELETE_APOLLO_ITEM_ERROR';
export const SELECTED_APOLLO_ITEM_ID='SELECTED_APOLLO_ITEM_ID';


// WEBPACK FOOTER //
// ./src/redux/projApollo/actionTypes.js